import * as angular from "angular";
import {IController} from "angular";

export class omsSettingsPanelTemplateCtrl implements IController {

  settings: any;
  panelRef: any;

  public settingsCopy: any;
  public enabledSections: {columns: boolean, dynamicColumns: boolean, packageDynamicColumns: boolean, viewSettings: boolean} = {
    columns: false,
    dynamicColumns: false,
    packageDynamicColumns: false,
    viewSettings: false
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
  }

  onColumnsChange(columns) {
    this.settingsCopy.columns = columns;
  }

  onDynamicColumnsChange(dynamicColumns) {
    this.settingsCopy.dynamicColumns = dynamicColumns;
  }

  onPackageDynamicColumnsChange(dynamicColumns) {
    this.settingsCopy.packageDynamicColumns = dynamicColumns;
  }

  onChangeDaysBefore(daysBefore) {
    if (!daysBefore) {
      daysBefore = 0;
    }
    this.settingsCopy.daysBefore = daysBefore;
  }

  onChangeDaysAfter(daysAfter) {
    if (!daysAfter) {
      daysAfter = 0;
    }
    this.settingsCopy.daysAfter = daysAfter;
  }

  onSelectedDefaultGroupChange(group) {
    this.settingsCopy.defaultGroup = group;
  }

  onToggleIsOpenColumns(isOpen) {
    this.enabledSections.columns = !this.enabledSections.columns;
  }

  onToggleIsOpenDynamicColumns(isOpen) {
    this.enabledSections.dynamicColumns = !this.enabledSections.dynamicColumns;
  }

  onToggleIsOpenPackageDynamicColumns(isOpen) {
    this.enabledSections.packageDynamicColumns = !this.enabledSections.packageDynamicColumns;
  }

  onToggleIsOpenViewSettings(isOpen) {
    this.enabledSections.viewSettings = !this.enabledSections.viewSettings;
  }

  onDateSortByChange(filterByCreatedAt) {
    this.settingsCopy.filterByCreatedAt = filterByCreatedAt;
  }

  // onChangeDynamicColumns(columnKey, isEnabled) {
  //   this.dynamicColumnsCopy[columnKey].enabled = isEnabled;
  // }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
.module('bringoz.admin.oms')
.component('omsSettingsPanelTemplate', {
  bindings: {
    settings: '<',
    panelRef: '<'
  },
  template: require('./oms-view-settings-panel-template.html').default,
  controller: omsSettingsPanelTemplateCtrl
});
